<div class="control-line mat-elevation-z8">
    <!-- Market (mat-select with in-panel search) -->
    <div class="filter-actions-line">
        <mat-form-field appearance="outline">
            <mat-label>Market</mat-label>
            <mat-select id="marketSelect" data-testid="marketSelect" [value]="selectedMarketId()"
                (selectionChange)="onMarketSelected($event.value)">
                <div class="mat-select-search-container" (click)="$event.stopPropagation()">
                    <input #marketFilterInput matInput placeholder="Search markets..." [value]="marketQuery()"
                        (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()"
                        (input)="onMarketQuery($event)" />

                    <mat-icon class="mat-select-search-icon">search</mat-icon>
                </div>
                <mat-option *ngFor="let m of marketsFiltered(); trackBy: trackByMarketId" [value]="m.id">
                    {{ m.regionName }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline">
            <mat-label>Disposal Site</mat-label>
            <mat-select id="disposalSiteSelect" data-testid="disposalSiteSelect" [value]="selectedSiteId()"
                (selectionChange)="onSiteSelected($event.value)">
                <div class="mat-select-search-container" (click)="$event.stopPropagation()">
                    <input #siteFilterInput matInput placeholder="Search Disposal Site..." [value]="siteQuery()"
                        class="mat-select-search-input" (click)="$event.stopPropagation()"
                        (keydown)="$event.stopPropagation()" (input)="onSiteQuery($event)" />

                    <mat-icon class="mat-select-search-icon">search</mat-icon>
                </div>
                <mat-option *ngFor="let m of sitesFiltered(); trackBy: trackBySiteId" [value]="m.id">
                    {{ m.siteName }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline">
            <mat-label>Enter a date range</mat-label>
            <mat-date-range-input id="dtRange" data-testid="dtRange" [formGroup]="range" [rangePicker]="picker">
                <input matStartDate id="startDateInput" placeholder="Start date" formControlName="start" (blur)="dateformat($event)" (keydown)="onKeydown($event)" >
                <input matEndDate id="endDateInput" placeholder="End date" formControlName="end" (blur)="dateformat($event)" (keydown)="onKeydown($event)">
            </mat-date-range-input>
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
        <button id="btnSearch" data-testid="btnSearch" mat-raised-button color="primary" (click)="onSearch()">
            <mat-icon>search</mat-icon>Search
        </button>
        @if(controlPermissions.addButton){
            <button id="btnUpdate" data-testid="btnUpdate" [disabled]="!hasAnyChange" mat-raised-button color="primary"
                (click)="onUpdate()">
                <mat-icon>update</mat-icon>Update
            </button>
        }
    </div>
</div>
<div class="gridheight mat-elevation-z8 viewport mar-top-20">
    <table mat-table [dataSource]="dataSource" class="excel-table" matSort>
        <ng-container *ngFor="let col of columns" [matColumnDef]="col.key">
            <ng-container [ngSwitch]="col.type">
                <th mat-header-cell *matHeaderCellDef>{{ col.label }}</th>
                <ng-container *ngSwitchCase="'date'">
                    <td *matCellDef="let row; let i = index" (click)="selectRow(i,col.key)">
                        <input matInput placeholder="MM/DD/YYYY"  [matDatepicker]="picker"
                            [formControl]="row.get(col.key)" />
                        <mat-datepicker #picker></mat-datepicker>
                    </td>
                </ng-container>

                <ng-container *ngSwitchCase="'hidden'">
                    <th mat-header-cell *matHeaderCellDef>{{ col.label }}</th>
                    <td *matCellDef="let row; let i = index" (click)="selectRow(i,col.key)">
                        <input type="hidden" [formControl]="row.get(col.key)" />
                    </td>
                </ng-container>
                <ng-container *ngSwitchDefault>
                    <th mat-header-cell *matHeaderCellDef>{{ col.label }}</th>
                    <td mat-cell *matCellDef="let row; let i = index" (click)="selectRow(i,col.key)"
                        (contextmenu)="onRightClick($event, i,col.key)">
                        <input matInput type="text" (input)="roundOff($event, 999999, 4, col.key)" [formControl]="row.get(col.key)" />
                    </td>
                </ng-container>
            </ng-container>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" [style.background-color]="row.__dirty ? '#fff4e5 !important' : null"></tr>
    </table>
</div>

<!-- <button mat-icon-button [matMenuTriggerFor]="rowMenu" #menuTrigger="matMenuTrigger" style="display:none">
</button>

<mat-menu #rowMenu="matMenu">
    <button mat-menu-item (click)="addRowBelow()">Add row below</button>
    <button mat-menu-item (click)="deleteRow()">Delete row</button>
</mat-menu> -->